import { useSettings } from "../../context/SettingsContext";
import { buildWhatsAppLink, telHref } from "../../lib/whatsapp";
import { WhatsAppIcon } from "./Icons";
import { Phone, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function StickyMobileBar() {
  const { settings } = useSettings();
  if (!settings) return null;
  const phone = "+916302206106";
  const wa = buildWhatsAppLink();
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-border shadow-[0_-4px_20px_rgba(11,37,69,0.08)] pb-safe" data-testid="mobile-sticky-bar">
      <div className="grid grid-cols-3 divide-x divide-border">
        {phone && (
          <a href={telHref} data-testid="sticky-call" className="flex flex-col items-center py-3 text-navy">
            <Phone className="w-5 h-5 mb-0.5" /><span className="text-[11px] font-medium">Call</span>
          </a>
        )}
        <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="sticky-whatsapp" className="flex flex-col items-center py-3 text-[#25D366]">
          <WhatsAppIcon className="w-5 h-5 mb-0.5" /><span className="text-[11px] font-medium">WhatsApp</span>
        </a>
        <Link to="/#booking" data-testid="sticky-book" className="flex flex-col items-center py-3 text-white bg-gold">
          <ArrowRight className="w-5 h-5 mb-0.5" /><span className="text-[11px] font-semibold">Book Now</span>
        </Link>
      </div>
    </div>
  );
}
